import { useRootLoaderData } from "../routing/useRootLoaderData";
import type { Representation } from "./Representation";

export function useRepresentationContext(): Representation {
  return useRootLoaderData().representation;
}
